import React from 'react';
import FormField from '../shared/FormField';
import formDataStorage from '../../utils/formDataStorage';
import { FileText, Info } from 'lucide-react';

// F2签证SEVIS信息表单
const F2SevisInfoForm = ({ data, onChange }) => {

  // 从formDataStorage读取数据并确保数据同步
  React.useEffect(() => {
    console.log('F2SevisInfoForm useEffect - 初始化数据检查');
    const savedData = formDataStorage.loadFormData('f2_sevis_info');
    console.log('F2SevisInfoForm useEffect - 已保存数据:', savedData);
    console.log('F2SevisInfoForm useEffect - 当前props数据:', data);
    
    // 如果有保存的数据但当前data为空或部分字段缺失，则从数据库加载
    if (savedData && (!data || Object.keys(data).length === 0)) {
      console.log('F2SevisInfoForm useEffect - 从数据库加载数据');
      Object.keys(savedData).forEach(key => {
        if (savedData[key] !== null && savedData[key] !== undefined) {
          onChange(key, savedData[key]);
        }
      });
    }
  }, [data, onChange]);

  // SEVIS ID验证函数
  const validateSevisId = (sevisId) => {
    if (!sevisId) return false;
    const sevisPattern = /^N\d{10}$/;
    return sevisPattern.test(sevisId);
  };

  // 处理SEVIS ID输入变化
  const handleSevisIdChange = (field, value) => {
    console.log(`🔍 F2SevisInfoForm - 字段变化: ${field} = ${value}`);
    onChange(field, value);
  };

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-lg">
        <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
          <span className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center mr-3 text-sm">📋</span>
          F2签证SEVIS信息
        </h3>

        <div className="bg-white p-6 rounded-lg shadow-sm mb-6">
          <h4 className="text-lg font-semibold text-gray-800 flex items-center mb-4">
            <FileText className="w-5 h-5 mr-2" />
            SEVIS身份证明信息
          </h4>

          <div className="space-y-6">
            {/* SEVIS ID */}
            <div className="field-group">
              <FormField
                label={
                  <div className="flex items-center">
                    <span>SEVIS ID</span>
                    <div className="ml-2 group relative">
                      <Info className="w-4 h-4 text-gray-400 cursor-help" />
                      <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-800 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-10">
                        SEVIS 身份证明
                        <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
                      </div>
                    </div>
                  </div>
                }
                value={data.sevis_id || ''}
                onChange={(e) => handleSevisIdChange('sevis_id', e.target.value)}
                placeholder="N0123456789"
                maxLength={11}
                required
                error={data.sevis_id && !validateSevisId(data.sevis_id) ? 'SEVIS ID格式不正确，请使用N + 10位数字的格式' : ''}
              />
              <div className="mt-2 text-sm text-gray-600 bg-gray-50 p-3 rounded-lg border-l-4 border-blue-400">
                <div className="flex items-center">
                  <Info className="w-4 h-4 mr-2 text-blue-500" />
                  <span>格式示例: N0123456789</span>
                </div>
              </div>
            </div>

            {/* 主申请人SEVIS ID */}
            <div className="field-group">
              <FormField
                label={
                  <div className="flex items-center">
                    <span>主申请人SEVIS ID</span>
                    <div className="ml-2 group relative">
                      <Info className="w-4 h-4 text-gray-400 cursor-help" />
                      <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-800 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-10">
                        主申请人的SEVIS号码
                        <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
                      </div>
                    </div>
                  </div>
                }
                value={data.principal_sevis_id || ''}
                onChange={(e) => handleSevisIdChange('principal_sevis_id', e.target.value)}
                placeholder="N0123456789"
                maxLength={11}
                required
                error={data.principal_sevis_id && !validateSevisId(data.principal_sevis_id) ? '主申请人SEVIS ID格式不正确，请使用N + 10位数字的格式' : ''}
              />
              <div className="mt-2 text-sm text-gray-600 bg-gray-50 p-3 rounded-lg border-l-4 border-blue-400">
                <div className="flex items-center">
                  <Info className="w-4 h-4 mr-2 text-blue-500" />
                  <span>格式示例: N0123456789</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 信息说明 */}
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 rounded-lg border-l-4 border-blue-400">
          <h5 className="font-semibold text-blue-800 mb-2 flex items-center">
            <Info className="w-5 h-5 mr-2" />
            重要说明
          </h5>
          <div className="text-sm text-blue-700 space-y-2">
            <p>• SEVIS ID是您在美国学生和交流访问者信息系统中的唯一标识符</p>
            <p>• 格式必须以字母"N"开头，后跟10位数字</p>
            <p>• 主申请人SEVIS ID是指F1签证持有者的SEVIS ID</p>
            <p>• 请确保输入的SEVIS ID准确无误</p>
          </div>
        </div>

        {/* 预览信息 */}
        {(data.sevis_id || data.principal_sevis_id) && (
          <div className="mt-6 p-4 bg-gradient-to-r from-green-50 to-blue-50 rounded-lg border-l-4 border-green-400 shadow-sm">
            <h4 className="font-semibold text-green-800 mb-2">信息预览</h4>
            <div className="text-sm text-green-700 space-y-1">
              {data.sevis_id && (
                <p><strong>SEVIS ID:</strong> {data.sevis_id} {validateSevisId(data.sevis_id) ? '✅' : '❌'}</p>
              )}
              {data.principal_sevis_id && (
                <p><strong>主申请人SEVIS ID:</strong> {data.principal_sevis_id} {validateSevisId(data.principal_sevis_id) ? '✅' : '❌'}</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default F2SevisInfoForm;
